enum ExpenseType {
  OOP = "OOP",
  CARD = "CARD",
  DIRECT_PAY = "DIRECTPAY",
  BENEFIT_TRANSFER = "BENEFIT_TRANSFER"
}

export { ExpenseType }
